export const dogs = [
  {
    id: 1,
    name: 'Tito',
    age: '2 anni',
    size: 'Piccola',
    character: 'Vivace e dolce',
    status: 'In cerca di casa',
    image: '/images/dog_1_1776854099944.png',
    bg: 'bg-green',
    story: 'Tito è un cagnolino pieno di energia che è stato trovato mentre vagava in una zona industriale. Nonostante le difficoltà iniziali, ha subito dimostrato di avere un cuore grande. Ama le lunghe passeggiate e giocare a palla. È un cane intelligente che impara in fretta. Cerca una famiglia dinamica che voglia condividere con lui tante avventure.',
    health: 'Vaccinato, microchippato, sverminato. Gode di ottima salute.',
    compatibility: 'Perfetto con i bambini, compatibile con altri cani di taglia simile.'
  },
  {
    id: 2,
    name: 'Luna',
    age: '4 anni',
    size: 'Media',
    character: 'Calma e affettuosa',
    status: 'In cerca di casa',
    image: '/images/dog_2_1776854115865.png',
    bg: 'bg-beige',
    story: 'Luna è arrivata da noi dopo che la sua precedente famiglia non poteva più occuparsene. È dolcissima, pacata e molto educata in casa. Adora farsi accarezzare la pancia e dormire vicino ai piedi del divano. Il suo sguardo dolce conquista chiunque al primo incontro.',
    health: 'Sterilizzata, vaccinata e in salute. Test leishmaniosi negativo.',
    compatibility: 'Ideale per un contesto familiare calmo. Va d\'accordo con i gatti.'
  },
  {
    id: 3,
    name: 'Scruffy',
    age: '1 anno',
    size: 'Piccola',
    character: 'Curioso e giocherellone',
    status: 'In cerca di casa',
    image: '/images/dog_3_1776854129774.png',
    bg: 'bg-peach',
    story: 'Scruffy è il più giovane del gruppo! Trovato abbandonato in uno scatolone insieme ai suoi fratellini (già adottati), Scruffy aspetta ancora il suo turno. È super curioso, vivace e sempre pronto a scoprire cose nuove. Vi riempirà la casa di divertimento e amore incondizionato.',
    health: 'Sano e vivace, ha completato l\'intero ciclo vaccinale.',
    compatibility: 'Essendo un cucciolone, va d\'accordo con tutti ma ha bisogno di educazione base.'
  }
];
